var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthDecreasing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bba8fa;opacity:0.15;}.b{fill:none;stroke:#bba8fa;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1,1,6.5,4.5V1L13,5.5m0,0v-3m0,3H9.5",
    transform: "translate(5 8.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthDecreasing);
export default __webpack_public_path__ + "static/media/growth-decreasing.b59dad74936dad72f7d82f93cf9c6718.svg";
export { ForwardRef as ReactComponent };